<template>
<div class="chapter">
<div class="inner_page">
<div id="Maps">
<p class="fm-title" id="map"><a id="pagexiv">List of Maps</a></p><a id="pagexiv">
<p class="center1"><b>In colour section</b></p>
<table border="0" cellpadding="0" cellspacing="0" style="margin-top:0.5em;" width="100%">
<colgroup>
<col width="05%"/>
<col width="95%"/>
</colgroup>
<tbody>
<tr>
<td valign="top"><p class="noindent3"> </p></td>
<td valign="top"><p class="noindent3"><span href="#/xhtml/17_Photogallery#map_0" title="Link target outside of Sample">Key to maps. We have followed the Second World War convention of showing British and Allied Symbols in red and German and Axis symbols in blue.</span></p></td>
</tr>
<tr>
<td valign="top"><p class="noindent3"><span href="#/xhtml/17_Photogallery#map_1" title="Link target outside of Sample">1</span></p></td>
<td valign="top"><p class="noindent3"><span href="#/xhtml/17_Photogallery#map_1" title="Link target outside of Sample">Overview of operations in Normandy.</span></p></td>
</tr>
<tr>
<td valign="top"><p class="noindent3"><span href="#/xhtml/17_Photogallery#map_2" title="Link target outside of Sample">2</span></p></td>
<td valign="top"><p class="noindent3"><span href="#/xhtml/17_Photogallery#map_2" title="Link target outside of Sample">German dispositions, early June 1944.</span></p></td>
</tr>
<tr>
<td valign="top"><p class="noindent3"><span href="#/xhtml/17_Photogallery#map_3" title="Link target outside of Sample">3</span></p></td>
<td valign="top"><p class="noindent3"><span href="#/xhtml/17_Photogallery#map_3" title="Link target outside of Sample">The Naval and Air support to Operation OVERLORD with UK concentration areas.</span></p></td>
</tr>
<tr>
<td valign="top"><p class="noindent3"><span href="#/xhtml/17_Photogallery#map_4" title="Link target outside of Sample">4</span></p></td>
<td valign="top"><p class="noindent3"><span href="#/xhtml/17_Photogallery#map_4" title="Link target outside of Sample">D-Day-the assault, 6 June.</span></p></td>
</tr>
<tr>
<td valign="top"><p class="noindent3"><span href="#/xhtml/17_Photogallery#map_5" title="Link target outside of Sample">5</span></p></td>
<td valign="top"><p class="noindent3"><span href="#/xhtml/17_Photogallery#map_5" title="Link target outside of Sample">The initial British assault up to midnight 6 June.</span></p></td>
</tr>
<tr>
<td valign="top"><p class="noindent3"><span href="#/xhtml/17_Photogallery#map_6" title="Link target outside of Sample">6</span></p></td>
<td valign="top"><p class="noindent3"><span href="#/xhtml/17_Photogallery#map_6" title="Link target outside of Sample">6th Airborne Division’s operations east of the River Orne.</span></p></td>
</tr>
<tr>
<td valign="top"><p class="noindent3"><span href="#/xhtml/17_Photogallery#map_7" title="Link target outside of Sample">7</span></p></td>
<td valign="top"><p class="noindent3"><span href="#/xhtml/17_Photogallery#map_7" title="Link target outside of Sample">The expansion of the British bridgehead 6-15 June.</span></p></td>
</tr>
<tr>
<td valign="top"><p class="noindent3"><span href="#/xhtml/17_Photogallery#map_8" title="Link target outside of Sample">8</span></p></td>
<td valign="top"><p class="noindent3"><span href="#/xhtml/17_Photogallery#map_8" title="Link target outside of Sample">Operations MARTLET and EPSOM, 25-26 June.</span></p></td>
</tr>
<tr>
<td valign="top"><p class="noindent3"><span href="#/xhtml/17_Photogallery#map_9" title="Link target outside of Sample">9</span></p></td>
<td valign="top"><p class="noindent3"><span href="#/xhtml/17_Photogallery#map_9" title="Link target outside of Sample">Operation CHARNWOOD, the capture of Caen, 7-9 July.</span></p></td>
</tr>
<tr>
<td valign="top"><p class="noindent3"><span href="#/xhtml/17_Photogallery#map_10" title="Link target outside of Sample">10</span></p></td>
<td valign="top"><p class="noindent3"><span href="#/xhtml/17_Photogallery#map_10" title="Link target outside of Sample">Operation GOODWOOD, 18-20 July.</span></p></td>
</tr>
<tr>
<td valign="top"><p class="noindent3"><span href="#/xhtml/17_Photogallery#map_11" title="Link target outside of Sample">11</span></p></td>
<td valign="top"><p class="noindent3"><span href="#/xhtml/17_Photogallery#map_11" title="Link target outside of Sample">Operation BLUECOAT, 30 July-7 August.</span></p></td>
</tr>
<tr>
<td valign="top"><p class="noindent3"><span href="#/xhtml/17_Photogallery#map_12" title="Link target outside of Sample">12</span></p></td>
<td valign="top"><p class="noindent3"><span href="#/xhtml/17_Photogallery#map_12" title="Link target outside of Sample">Operations TOTALIZE and TRACTABLE, 8-21 August.</span></p></td>
</tr>
<tr>
<td valign="top"><p class="noindent3"><span href="#/xhtml/17_Photogallery#map_13" title="Link target outside of Sample">13</span></p></td>
<td valign="top"><p class="noindent3"><span href="#/xhtml/17_Photogallery#map_13" title="Link target outside of Sample">The crossing of the River Seine at Vernon, 25-27 July.</span></p></td>
</tr>
<tr>
<td valign="top"><p class="noindent3"><span href="#/xhtml/17_Photogallery#map_14" title="Link target outside of Sample">14</span></p></td>
<td valign="top"><p class="noindent3"><span href="#/xhtml/17_Photogallery#map_14" title="Link target outside of Sample">The ‘Great Swan’-the advance beyond the River Seine and into Belgium.</span></p></td>
</tr>
<tr>
<td valign="top"><p class="noindent3"><span href="#/xhtml/17_Photogallery#map_15" title="Link target outside of Sample">15</span></p></td>
<td valign="top"><p class="noindent3"><span href="#/xhtml/17_Photogallery#map_15" title="Link target outside of Sample">The British maintenance and administrative set-up in Normandy including RAF airfields.</span></p></td>
</tr>
</tbody>
</table>
</a></div><a id="pagexiv">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 08_Maps.vue?082872fc